/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideen für Zwischenstopps auf Ihrer Route`
};

const en_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideas for stops along the way`
};

const es_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideas de paradas en el camino`
};

const fr_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Des idées d’escales sur votre route`
};

const it_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Idee per le soste lungo il percorso`
};

const nl_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideeën voor stops onderweg`
};

const pt_launchpad__zois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ideias para paragens no caminho`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__zois_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__zois_title", locale)
	if (locale === "de") return de_launchpad__zois_title(inputs)
	if (locale === "en") return en_launchpad__zois_title(inputs)
	if (locale === "es") return es_launchpad__zois_title(inputs)
	if (locale === "fr") return fr_launchpad__zois_title(inputs)
	if (locale === "it") return it_launchpad__zois_title(inputs)
	if (locale === "nl") return nl_launchpad__zois_title(inputs)
	return pt_launchpad__zois_title(inputs)
};